<template>
  <div class="tnc-wrapper">
    <h2><span style="font-size: 16pt">Syarat &amp; Ketentuan</span></h2>
    <h4>
      <strong><span style="font-size: 12pt">Aturan umum</span></strong>
    </h4>
    <ol>
      <li style="list-style-type: decimal; font-size: 10.5pt">
        <p>
          <span style="font-size: 10.5pt">Situs web kami hanya dibatasi untuk individu dengan usia legal sebagaimana
            ditentukan dalam yurisdiksi
            tempat individu tersebut tinggal.</span>
        </p>
      </li>
      <li style="list-style-type: decimal; font-size: 10.5pt">
        <p>
          <span style="font-size: 10.5pt">Situs web kami tidak bertanggung jawab atas hukum nasional, hukum federal,
            atau hukum internasional apa pun
            yang dilanggar oleh pengguna mana pun yang menggunakan situs web kami.</span>
        </p>
      </li>
      <li style="list-style-type: decimal; font-size: 10.5pt">
        <p>
          <span style="font-size: 10.5pt">Pengguna bertanggung jawab atas tindakan mereka sendiri dan terikat oleh
            undang-undang negara mereka
            sendiri, yang mencakup undang-undang negara bagian atau masalah hukum.</span>
        </p>
      </li>
      <li style="list-style-type: decimal; font-size: 10.5pt">
        <p>
          <span style="font-size: 10.5pt">Semua agen bertanggung jawab atas akun anggotanya masing-masing, dan akan
            menghormati semua taruhan yang
            dikonfirmasi yang dikirimkan oleh mereka.</span>
        </p>
      </li>
      <li style="list-style-type: decimal; font-size: 10.5pt">
        <p>
          <span style="font-size: 10.5pt">Agen bukanlah mitra website Kami. Oleh karena itu situs kami tidak bertanggung
            jawab atas perbedaan atau
            perselisihan apa pun antara Pemain dan Agen.</span>
        </p>
      </li>
      <li style="list-style-type: decimal; font-size: 10.5pt">
        <p>
          <span style="font-size: 10.5pt">Merupakan tanggung jawab pengguna untuk menjaga ID Pengguna dan Kata Sandinya
            dari penggunaan yang tidak
            sah. Jika ID Pengguna dan Kata Sandi pengguna dicuri atau dibobol, pengguna bertanggung jawab untuk segera
            menghubungi agennya. Agen kemudian akan mengubah User ID dan Password penggunanya.</span>
        </p>
      </li>
      <li style="list-style-type: decimal; font-size: 10.5pt">
        <p>
          <span style="font-size: 10.5pt">Jika terjadi pencurian ID Pengguna dan Kata Sandi, pengguna bertanggung jawab
            atas akunnya masing-masing
            dan akan menghormati semua taruhan yang dikonfirmasi yang diajukan.</span>
        </p>
      </li>
    </ol>
    <h4>
      <strong><span style="font-size: 12pt">Aturan Permainan</span></strong>
    </h4>
    <ol>
      <li style="list-style-type: decimal; font-size: 10.5pt">
        <p>
          <span style="font-size: 10.5pt">Hasil pertandingan yang diputuskan oleh website kami bersifat final dan
            mengikat.</span>
        </p>
      </li>
      <li style="list-style-type: decimal; font-size: 10.5pt">
        <p>
          <span style="font-size: 10.5pt">Dalam semua kasus perselisihan, baik manajemen situs web Kami maupun pemain
            harus menyetujui bahwa basis
            data log transaksi situs web Kami akan berfungsi sebagai penengah terakhir dalam perselisihan tersebut.
            Semua perselisihan harus diajukan pada hari dimana hasil pertandingan ditentukan. Tidak ada klaim yang akan
            dipenuhi setelah hari pertandingan.</span>
        </p>
      </li>
      <li style="list-style-type: decimal; font-size: 10.5pt">
        <p>
          <span style="font-size: 10.5pt">Pemain bertanggung jawab penuh untuk memverifikasi keakuratan semua transaksi
            akun mereka.</span>
        </p>
      </li>
      <li style="list-style-type: decimal; font-size: 10.5pt">
        <p>
          <span style="font-size: 10.5pt">Harap pastikan untuk meninjau taruhan Anda untuk setiap kesalahan, kesalahan
            atau kelalaian sebelum
            mengirimkannya melalui komputer. Setelah taruhan diterima melalui komputer, taruhan tersebut tidak dapat
            diubah atau dibatalkan.</span>
        </p>
      </li>
      <li style="list-style-type: decimal; font-size: 10.5pt">
        <p>
          <span style="font-size: 10.5pt">Kami berhak membekukan atau membatalkan akun pelanggan mana pun yang ditemukan
            melanggar Syarat dan
            Ketentuan ini, terlibat dalam aktivitas penipuan, masuk tanpa izin, menyerang, memalsukan, merusak aturan
            standar, atau terlibat dalam sindikat taruhan, yang mengakibatkan semua saldo akun dibekukan dan hangus.
            tanpa pemberitahuan sebelumnya.</span>
        </p>
      </li>
      <li style="list-style-type: decimal; font-size: 10.5pt">
        <p>
          <span style="font-size: 10.5pt">Kami berhak membatalkan atau menyatakan tidak sah setiap taruhan atau tiket
            yang diketahui berkaitan dengan taruhan sindikat, taruhan terkoordinasi, kolusi, penipuan, penyalahgunaan
            sistem, pemanfaatan kesalahan teknis, odds yang keliru, atau upaya lain untuk memperoleh keuntungan yang
            tidak adil. Setiap kemenangan terkait dapat dibatalkan, dan akun terkait dapat ditangguhkan atau
            ditutup.</span>
        </p>
      </li>
    </ol>
    <h4>
      <strong><span style="font-size: 12pt">Batasan dan Kewajiban</span></strong>
    </h4>
    <ol>
      <li style="list-style-type: decimal; font-size: 10.5pt">
        <p>
          <span style="font-size: 10.5pt">Tanpa mengurangi ketentuan umum di atas, Situs web Kami tidak akan bertanggung
            jawab kepada siapa pun jika
            terjadi sabotase, force majeure, dan/atau atas peristiwa kegagalan atau kerusakan atau kehancuran pada
            sistem komputer pusat atau catatan atau bagian mana pun dari situs web Kami. daripadanya, atau penundaan,
            kehilangan, kesalahan, kelalaian atau hal lainnya yang disebabkan oleh kegagalan sistem telekomunikasi atau
            transmisi data apa pun, atau penundaan apa pun yang mengakibatkan tidak diterimanya entri apa pun untuk
            perlombaan tertentu.</span>
        </p>
      </li>
      <li style="list-style-type: decimal; font-size: 10.5pt">
        <p>
          <span style="font-size: 10.5pt">Situs web kami tidak bertanggung jawab atas segala kerugian yang disebabkan
            oleh takdir Tuhan, pecahnya
            permusuhan, kerusuhan, kerusuhan sipil, aksi terorisme, tindakan pemerintah atau pihak berwenang (termasuk
            penolakan atau pencabutan lisensi atau persetujuan apa pun), ledakan kebakaran, banjir, pencurian,
            pengrusakan berbahaya, pemogokan, penutupan perusahaan dan tindakan industrial dalam bentuk apa pun.</span>
        </p>
      </li>
      <li style="list-style-type: decimal; font-size: 10.5pt">
        <p>
          <span style="font-size: 10.5pt">Jika terjadi kesalahan koneksi jaringan, komunikasi, sistem atau manusia yang
            menyebabkan masalah terkait
            taruhan seperti penerimaan taruhan ganda, taruhan tidak dapat dikonfirmasi, memasang taruhan setelah
            pertandingan dimulai, dll. Kami berhak jika terjadi hal tersebut kesalahan untuk mengatasinya berdasarkan
            kasus per kasus dan juga untuk mengambil tindakan lain untuk memperbaiki kesalahan tersebut. Kami tidak
            bertanggung jawab kepada Anda atau pihak ketiga mana pun sehubungan dengan kesalahan tersebut. Jika Anda
            pernah mengalami kesalahan tersebut dan terus bertaruh tanpa melapor ke upline Anda, Anda akan bertanggung
            jawab dan menghormati semua hasil menang/kalah jika kesalahan tersebut terjadi lagi.</span>
        </p>
      </li>
      <li style="list-style-type: decimal; font-size: 10.5pt">
        <p>
          <span style="font-size: 10.5pt">Peraturan dan Ketentuan ini merupakan keseluruhan kesepakatan dan kesepahaman
            antara para pihak.</span>
        </p>
      </li>
      <li style="list-style-type: decimal; font-size: 10.5pt">
        <p>
          <span style="font-size: 10.5pt">Apabila terdapat perbedaan antara versi bahasa Inggris dari Peraturan dan
            Regulasi ini dengan versi bahasa
            lainnya, maka versi bahasa Inggris akan menggantikan bahasa lainnya dan dianggap benar dan sah.</span>
        </p>
      </li>
    </ol>
    <BurgerMenu v-if="isMobile" />
  </div>
</template>
<script>
  import BurgerMenu from '@/components/burger-menu.vue';
  import { isMobile } from 'mobile-device-detect';
  export default {
    components: {
      BurgerMenu,
    },
    data: () => {
      return {
        isMobile,
      };
    },
  };
</script>
<style lang="scss" scoped>
  .tnc-wrapper {
    padding: 16px 24px;
    box-sizing: border-box;
    height: calc(100% - 56px);
    overflow-y: auto;
  }

  strong,
  h2,
  h4 {
    font-weight: 600;
  }
</style>
